var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCirleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.9288,
    cy: 12,
    rx: 11.9288,
    ry: 12,
    fill: "#8CC53F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3576 12C23.3576 18.3541 18.2379 23.5 11.9288 23.5C5.61964 23.5 0.5 18.3541 0.5 12C0.5 5.64592 5.61964 0.5 11.9288 0.5C18.2379 0.5 23.3576 5.64592 23.3576 12Z",
    stroke: "black",
    strokeOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6985 8L10.6154 13.5966L7.30154 10.5563L6 11.7537L10.6154 16L18 9.20594L16.6985 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCirleIcon);
export default __webpack_public_path__ + "static/media/CheckCirleIcon.52073e88f192ab85bf00761ff613e179.svg";
export { ForwardRef as ReactComponent };